<template src="./ProjectMemberPicker.html"></template>

<script>
import { getAssignableUsers } from '../../services'

// XAN-193 (adjustments) — MODULE-level universe: any Risk Shield role except Analista, that is
// ADMIN, RISK_SHIELD, RISK_SHIELD_ADMIN, COMPLIANCE, COMPLIANCE_ADMIN and ACCOUNTING.
//
// This used to be assembled client-side by calling GET /users once per role, because that endpoint
// pages at 100 users and filtering on the client dropped anyone falling past the 100th name
// alphabetically. A dedicated endpoint (GET /project/assignable-users) now applies the same filter
// in the backend, so the list of allowed roles is no longer duplicated in two places that could
// drift apart.
//
// This component only renders for ADMIN: it is the only role that may assign users to a project,
// and the endpoint enforces that too.
export default {
  name: 'ProjectMemberPicker',
  props: {
    // Selected user ids.
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    users: []
  }),
  created () {
    this.listUsers()
  },
  methods: {
    async listUsers () {
      try {
        const users = await getAssignableUsers()
        this.users = users.map((user) => ({ ...user, fullname: `${user.name} ${user.lastName || ''}`.trim() }))
      } catch (err) {
        console.error('Error listing assignable users:', err)
      }
    }
  }
}
</script>
